import { Instance, SnapshotIn, types } from "mobx-state-tree";

export const PollAnswerModel = types.model({
  id: types.number,
  contents: types.string,
  results: types.number,
  selected: types.boolean,
});

export interface PollAnswerInstance extends Instance<typeof PollAnswerModel> {}
export interface PollAnswerSnapshot extends SnapshotIn<typeof PollAnswerModel> {}
